export default __webpack_public_path__ + "static/media/add-bank.b7511d43.jpg";